module.exports = __webpack_public_path__ + "img/airplane-4.49426e6e.jpg";